<div class="numkeys" [class.disabled-clicks]="isLoading">
  @if (isLoading) {
    <div class="overlay">
      <mat-spinner [diameter]="20" strokeWidth="3"></mat-spinner>
    </div>
  }
  @for (key of keys; track key) {
    <div class="key" (click)="eventOnKeyPress.emit(key)">
      <mat-card appearance="outlined">{{ key }}</mat-card>
    </div>
  }
  <div class="key clr" (click)="eventOnclear.emit()">
    <mat-card appearance="outlined">CLR</mat-card>
  </div>
  <div class="key" (click)="eventOnKeyPress.emit('0')">
    <mat-card appearance="outlined">0</mat-card>
  </div>
  <div class="key ok" (click)="eventOnOk.emit()">
    <mat-card appearance="outlined">OK</mat-card>
  </div>
</div>
